import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// One-glance staleness check: compare this stamp against the latest compile when
// debugging "phantom" errors — DevTools console history survives HMR hot-swaps,
// so old ReferenceErrors can sit above a healthy, already-patched app.
console.info("Inn-dulGe web · compiled", process.env.REACT_APP_BUILD_STAMP || "dev");

// Global safety net: turn a bare "Uncaught (in promise) Object" into a single
// readable line and stop it spamming the console. Fetch/axios failures that matter
// are already surfaced as user toasts at their call sites; this only tidies the
// stragglers (e.g. a socket/verify promise that rejects after unmount).
window.addEventListener("unhandledrejection", (e) => {
  const r = e?.reason;
  const msg = r?.response?.status
    ? `HTTP ${r.response.status} ${r.config?.method || ""} ${r.config?.url || ""}`.trim()
    : (r?.message || (typeof r === "string" ? r : "promise rejected"));
  console.warn("[inndulge] handled promise rejection:", msg);
  e.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
    // M1 stale-bundle fix: when a new worker takes over (skipWaiting + claim), this page
    // is still running the OLD bundle — show a brief note and pull the fresh one.
    let hadController = Boolean(navigator.serviceWorker.controller);
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!hadController) { hadController = true; return; } // first install — nothing stale
      if (sessionStorage.getItem("inndulge_sw_reloaded")) return; // loop guard
      sessionStorage.setItem("inndulge_sw_reloaded", "1");
      const note = document.createElement("div");
      note.textContent = "App updated — refreshing…";
      note.style.cssText =
        "position:fixed;bottom:18px;left:50%;transform:translateX(-50%);z-index:99999;" +
        "background:#3A342E;color:#F8F4EE;padding:10px 18px;border-radius:999px;" +
        "font:14px Jost,sans-serif;box-shadow:0 4px 18px rgba(0,0,0,.25)";
      document.body.appendChild(note);
      setTimeout(() => window.location.reload(), 900);
    });
  });
}
